import React from "react";

const CTA = () => {
  return (
    <div className="border-t lg:ps-40 ps-5 pt-16 relative">
      <div className="flex flex-col lg:flex-row items-center justify-between">
        <div className="w-full lg:w-3/4 mb-12 lg:mb-0">
          <h1 className="text-4xl font-semibold text-[#212F40] leading-tight mb-8">
            Access all your marketing <br /> data without leaving <br /> Google Workspace
          </h1>
          <button className="inline-flex items-center px-6 py-3 bg-[#1B91F0] hover:bg-blue-600  hover:scale-105 transition-transform duration-300  text-white font-medium rounded-lg transition-colors">
            Install Now
            <svg
              className="ml-2 w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
              />
            </svg>
          </button>
        </div>

        <div className="">
          <div className="relative">
            <img
              src="/CTA/cta.svg"
              alt="Google Workspace Interface"
              className="w-max h-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTA;
